import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'

import Home from './pages/Home'
import Login from './pages/Login'
import Signup from './pages/Signup'
import SignupClient from './pages/SignupClient'
import SignupBookkeeper from './pages/SignupBookkeeper'
import Directory from './pages/Directory'
import Profile from './pages/Profile'
import Pricing from './pages/Pricing'
import HowItWorks from './pages/HowItWorks'
import Dashboard from './pages/Dashboard'
import UploadDocs from './pages/UploadDocs'
import Messages from './pages/Messages'
import About from './pages/About'
import Contact from './pages/Contact'
import FAQ from './pages/FAQ'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import Admin from './pages/Admin'
import BlogList from './pages/BlogList'
import BlogArticle from './pages/BlogArticle'
import IntakeStart from './pages/IntakeStart'
import IntakeWizard from './pages/IntakeWizard'
import IntakeSubmitted from './pages/IntakeSubmitted'
import IntakeReview from './pages/IntakeReview'

//mobile app handling
import { isApp } from './utils/platform';
import HomeMobile from "./pages_mobile/HomeMobile"
import ProductOfferings from './pages/ProductOfferings'
import PartnerWUs from './pages/PartnerWUs'
export default function App() {

  //const getPlatform = () => {
  //  if (window.cordova) {
  //    // This is the Cordova mobile app
  //    return 'mobile';
  //  } else {
  //    // This is a standard web browser
  //    return 'web';
  //  }
  //};

  if(isApp){
    return(
      <Router>
        <Navbar />
        <main style={{ padding: '28px 20px', maxWidth: 1100, margin: '0 auto' }}>
          
          <Routes>
            <Route path="/" element={<HomeMobile />} />
          </Routes>
        </main>
      </Router>
    )

  }
  else{
    return (
      <Router>
        <div style={{display:"flex", flexDirection:"column", height:"100vh"}}>
        <Navbar style={{height:"25%"}}/>
        <main style={{ padding: '40px 20px', flexGrow:1, width:"100%", maxWidth: 1100, margin: '0 auto' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/signup-client" element={<SignupClient />} />
            <Route path="/signup-bookkeeper" element={<SignupBookkeeper />} />
            <Route path="/directory" element={<ProductOfferings />} />
            <Route path="/profile/:id" element={<Profile />} />
            <Route path="/partner-with-us" element={<PartnerWUs />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/directory" element={<Directory />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/upload" element={<UploadDocs />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/intake/start" element={<IntakeStart />} />
            <Route path="/intake" element={<IntakeWizard />} />
            <Route path="/intake/review" element={<IntakeReview />} />
            <Route path="/intake/submitted" element={<IntakeSubmitted />} />

          </Routes>
        </main>
        <Footer/>
        </div>
      </Router>
    )
  }

}
